import { navigate } from '@hwm/ui-lib/core';
import { useMemo } from 'react';
import { URLParams, useQuery } from './useQuery';

export const setSiteIdURL = (siteId: string) => {
  navigate({
    search: { siteId: siteId },
  });
};

export const useSiteIdState = () => {
  const query = useQuery();

  const siteIdURL = useMemo(() => {
    return query.get(URLParams.siteId);
  }, [query]);

  return { siteIdURL };
};
